import { DARK, LIGHT } from '@core/constants/theme';
import { useState, useEffect } from 'react';

export default () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const mediaQuery = window?.matchMedia('(prefers-color-scheme: dark)');
    setIsDark(mediaQuery.matches);

    const listener = (e) => setIsDark(e.matches);

    // Handle both modern and legacy browsers
    if (mediaQuery) {
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', listener);
      } else {
        mediaQuery.addListener(listener);
      }
    }

    return () => {
      if (mediaQuery) {
        if (mediaQuery.removeEventListener) {
          mediaQuery.removeEventListener('change', listener);
        } else {
          mediaQuery.removeListener(listener);
        }
      }
    };
  }, []);

  return isDark ? DARK : LIGHT;
};
